var _mask, _path, _path2, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 36,
    viewBox: "0 0 54 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4917_22807",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 18C0.5 8.05888 8.55888 0 18.5 0H35.5C45.4411 0 53.5 8.05888 53.5 18C53.5 27.9411 45.4411 36 35.5 36H18.5C8.55887 36 0.5 27.9411 0.5 18Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 18C0.5 8.05888 8.55888 0 18.5 0H35.5C45.4411 0 53.5 8.05888 53.5 18C53.5 27.9411 45.4411 36 35.5 36H18.5C8.55887 36 0.5 27.9411 0.5 18Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0V1.5H35.5V0V-1.5H18.5V0ZM35.5 36V34.5H18.5V36V37.5H35.5V36ZM18.5 36V34.5C9.3873 34.5 2 27.1127 2 18H0.5H-1C-1 28.7696 7.73045 37.5 18.5 37.5V36ZM53.5 18H52C52 27.1127 44.6127 34.5 35.5 34.5V36V37.5C46.2696 37.5 55 28.7696 55 18H53.5ZM35.5 0V1.5C44.6127 1.5 52 8.8873 52 18H53.5H55C55 7.23045 46.2696 -1.5 35.5 -1.5V0ZM18.5 0V-1.5C7.73045 -1.5 -1 7.23045 -1 18H0.5H2C2 8.8873 9.3873 1.5 18.5 1.5V0Z",
    fill: "#E6E7E8",
    mask: "url(#path-1-inside-1_4917_22807)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 18,
    r: 3.5,
    fill: "#6E7485"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 18,
    r: 3.5,
    fill: "#6E7485"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 18,
    r: 3.5,
    fill: "#6E7485"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterImg);
export default __webpack_public_path__ + "static/media/filter_img.e5219381769474d644284ef141ce29ad.svg";
export { ForwardRef as ReactComponent };